function TwitterIcon() {
    return (
        <svg
            id="ehXKkcSAL4t1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 36 36"
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
            className="size-9"
        >
            <rect
                width="35.0842"
                height="35.0842"
                rx="17.5421"
                ry="17.5421"
                transform="translate(.457895 0.457895)"
                fill="#fff"
                stroke="#1f4464"
                strokeWidth="0.915789"
            />
            <path
                d="M19.9026,16.892L27.348,8h-1.7643l-6.4648,7.7209L13.9555,8L8,8l7.8081,11.6753L8,29h1.76449l6.82711-8.1535L22.0445,29L28,29L19.9024,16.892h.0005-.0003Zm-2.4167,2.886l-.7911-1.1625-6.2947-9.25091h2.71l5.08,7.46581.7911,1.1625l6.6033,9.7043h-2.71l-5.3884-7.9188v-.0005l-.0002.0001Z"
                fill="#1f4464"
            />
        </svg>
    );
}

export default TwitterIcon;
